import './styles/global.css';
import { App } from './App';

async function main() {
  const app = new App();
  await app.initialize();
  
  const appElement = document.getElementById('app');
  if (appElement) {
    appElement.appendChild(app.getElement());
  }
}

main().catch(console.error);